'use es6';

import { createAction } from 'flux-actions';
import { ATTACHMENT_UPLOAD_START } from '../constants/fileUploadsActionTypes';
export const attachmentUploadStart = createAction(ATTACHMENT_UPLOAD_START, ({
  attachment,
  threadId
}) => ({
  attachment,
  threadId
}));